module.exports = __webpack_public_path__ + "img/03-B04.92eb276d.png";